import { NavLink } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <NavLink to="/" className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/20">
                  <i className="ri-camera-lens-line text-background-50 text-base"></i>
                </span>
                <span className="text-lg font-semibold font-heading text-background-50 whitespace-nowrap">
                  草莓色研社
                </span>
              </NavLink>
              <p className="text-sm text-background-50/70 leading-relaxed">
                国内首个专注于草莓视频色彩校正与拍摄技巧的专业内容平台，让每一颗草莓在镜头前绽放最美的色彩。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <NavLink
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                更多分类
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <NavLink
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                关于我们
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <NavLink
                    to="/about"
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200"
                  >
                    品牌介绍
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/about#team"
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200"
                  >
                    团队成员
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/about#contact"
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200"
                  >
                    联系我们
                  </NavLink>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-sm text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm text-background-50"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/15 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/50">
              &copy; 2026 草莓色研社. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors" rel="nofollow">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}